import React, { useState, useEffect } from 'react';
import { Chart } from "react-google-charts";

function CompositeTrades(props) {
    const [stats, setStats] = useState(null);

    useEffect(() => {
        (async function () {

            const url = `/api/algoCompositeStats`
            const stats = await (await fetch(url)).json();
            console.log("stats", stats);
            setStats(stats);

        })();
    }, []);


    function getChartData() {
        let chartData = [["Symbol", "Active Trades %", "Active Trend Following %", "Active Mean Reversion %"]];
        if (stats) {
            for (let stat in stats) {
                let symbolStats = stats[stat];
                let activeTotal = (symbolStats.activeTrades / symbolStats.totalAlgos) * 100;
                let activeTrendFollowing = (symbolStats.activeTrendFollowing / symbolStats.totalTrendFollowing) * 100;
                let activeMeanReversion = (symbolStats.activeMeanReversion / symbolStats.totalMeanReversion) * 100;
                chartData.push([symbolStats.symbol, activeTotal, activeTrendFollowing, activeMeanReversion]);
            }
        }
        return chartData;
    }

    const chartData = getChartData();

    return (<div>
        {chartData.length > 1 ?
            <Chart
                chartType="Bar"
                width="100%"
                height="400px"
                data={chartData}
                loader={<div>Loading Chart</div>}
                options={
                    {
                        vAxis: {
                            viewWindowMode: 'explicit',
                            viewWindow: {
                                max: 100,
                                min: 0
                            }
                        }
                    }
                }
            />
            : <div>No data</div>
        }
    </div>
    );
}

export default CompositeTrades;